import { mapArtistType, useFindArtistSuspense } from '@api';
import { BankAccounts, useBankAccountMutations } from '@common';
import { usePermissionContext } from '@hypeit-gmbh/hypeit-ui-core';
import { Route } from 'src/routes/_rootLayout/artists/$id.finance';
import { useCreateArtistBankAccount } from './hooks';

export const ArtistBankAccounts: React.FC = () => {
  const { id } = Route.useParams();
  const { data: artist } = useFindArtistSuspense(id, {
    query: { select: (data) => mapArtistType(data.data) },
  });

  const { hasPermission } = usePermissionContext();
  const userCanEditFinance = hasPermission({
    permission: 'FINANCE',
    action: 'WRITE',
  });

  const { submitCreateBankAccount } = useCreateArtistBankAccount(artist.id);
  const {
    submitUpdateBankAccount,
    submitDeleteBankAccount,
    handleApproveBankAccount,
    isDeletePending,
  } = useBankAccountMutations();

  return (
    <div data-testid="artist-bank-accounts-card">
      <BankAccounts
        bankAccounts={artist.bankAccounts}
        canEdit={userCanEditFinance}
        onSubmitCreate={submitCreateBankAccount}
        onSubmitUpdate={submitUpdateBankAccount}
        onSubmitDelete={submitDeleteBankAccount}
        onApprove={handleApproveBankAccount}
        isDeletePending={isDeletePending}
      />
    </div>
  );
};
